'use client';
import CaretLeft from '@/app/_components/ui/icons/CaretLeft.svg';
import React, { useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import Link from 'next/link';
import { popularBrands } from '@/app/_libs/utils/constants/index-contants';
import Image from 'next/image';

export default function BrandsSlider({ title = true }) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    const swiperInstance = swiperRef.current;
    prevRef.current.addEventListener('click', () => {
      swiperInstance.swiper.slidePrev();
    });

    nextRef.current.addEventListener('click', () => {
      swiperInstance.swiper.slideNext();
    });
  }, []);

  const swiperBreakpoints = {
    320: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    // when window width is >= 480px
    480: {
      slidesPerView: 3,
    },
    // When window width is >= 640px
    640: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    // When window width is >= 768px
    768: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    // When window width is >= 1024px
    1024: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
  };

  return (
    <div className="bg-[#F1F9FF] md:py-6 py-2 mt-2">
      <div className="container relative">
        {title && (
          <div className="carousel-head mb-6 text-center relative text-center ">
            <h2 className="text-gray-900 relative px-3 z-10 bg-[#F1F9FF] md:text-xl font-bold inline-block lg:max-w-none">
              محبوب ترین برندها
            </h2>
          </div>
        )}

        <Swiper
          ref={swiperRef}
          loop // Enable loop mode
          spaceBetween={20}
          slidesPerView={6}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          speed={2000}
          modules={[Autoplay, Navigation]}
          breakpoints={swiperBreakpoints}
        >
          {Object.keys(popularBrands).length > 0 ? (
            popularBrands.map((brand, index) => (
              <SwiperSlide key={index} className="overflow-hidden">
                <Link
                  href={brand.url}
                  className="rounded-md flex items-center justify-center overflow-hidden"
                >
                  <Image
                    width={200}
                    height={110}
                    src={
                      brand.image.full_path
                        ? brand.image.full_path
                        : '/images/no-image.jpg'
                    }
                    alt={brand.image?.alt}
                  />
                </Link>
              </SwiperSlide>
            ))
          ) : (
            <div className="w-full">
              <p className="text-center block"> نتیجه‌ای یافت نشد!</p>
            </div>
          )}
        </Swiper>
        <div
          className={`flex justify-between mt-4 rounded-md absolute w-full ${
            title ? ' top-10 md:top-20' : 'md:top-5 top-0 '
          } left-0 right-0  `}
        >
          <div
            ref={prevRef}
            className="bg-white px-3 py-2 rounded-md cursor-pointer shadow-sm z-10"
          >
            <CaretLeft className="rotate-180" />
          </div>
          <div
            ref={nextRef}
            className="bg-white px-3 py-2 rounded-md cursor-pointer shadow-sm z-10"
          >
            <CaretLeft />
          </div>
        </div>
      </div>
    </div>
  );
}
